import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SystemConfig {
  readonly timeoutPeriod: number; // Fixed at 30 seconds
  emailDeliveryRequired: boolean;
  setEmailDeliveryRequired: (required: boolean) => void;
}

export const useSystemConfig = create<SystemConfig>()(
  persist(
    (set) => ({
      timeoutPeriod: 30, // Fixed at 30 seconds
      emailDeliveryRequired: true,
      setEmailDeliveryRequired: (required) => set({ emailDeliveryRequired: required }),
    }),
    {
      name: 'system-config',
    }
  )
);